import { Box } from '@mui/material';
import InfoButton from './infoButton';

// Generic layout wrapper that places an info button next to any form field.
// Usable anywhere in the app - just pass an `info` object shaped as
// { title, description }, typically sourced from `constants/fieldInfo.js`.
const FieldWithInfo = ({ info, children }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
    <InfoButton info={info} />
  </Box>
);

export default FieldWithInfo;
